import { POIUtility } from "../../../utils/models/POI";
import bnbIcon from "../../../images/planner/highlights/bnb.png";
import busStopIcon from "../../../images/planner/highlights/bus_stop.png";
import campgroundIcon from "../../../images/planner/highlights/campground.png";
import caveIcon from "../../../images/planner/highlights/cave.png";
import coffeeIcon from "../../../images/planner/highlights/coffee.png";
import evChargingIcon from "../../../images/planner/highlights/ev_charging.png";
import fastfoodIcon from "../../../images/planner/highlights/fastfood.png";
import gateIcon from "../../../images/planner/highlights/gate.png";
import healthcareIcon from "../../../images/planner/highlights/healthcare.png";
import historyIcon from "../../../images/planner/highlights/history.png";
import hostelIcon from "../../../images/planner/highlights/hostel.png";
import hotelIcon from "../../../images/planner/highlights/hotel.png";
import informationIcon from "../../../images/planner/highlights/information.png";
import junctionIcon from "../../../images/planner/highlights/junction.png";
import motelIcon from "../../../images/planner/highlights/motel.png";
import parkingIcon from "../../../images/planner/highlights/parking.png";
import peakIcon from "../../../images/planner/highlights/peak.png";
import pharmacyIcon from "../../../images/planner/highlights/pharmacy.png";
import picnicIcon from "../../../images/planner/highlights/picnic.png";
import playgroundIcon from "../../../images/planner/highlights/playground.png";
import postOfficeIcon from "../../../images/planner/highlights/post_office.png";
import pubIcon from "../../../images/planner/highlights/pub.png";
import restaurantIcon from "../../../images/planner/highlights/restaurant.png";
import restroomIcon from "../../../images/planner/highlights/restroom.png";
import shelterIcon from "../../../images/planner/highlights/shelter.png";
import shopIcon from "../../../images/planner/highlights/shop.png";
import storageIcon from "../../../images/planner/highlights/storage.png";
import swimmingIcon from "../../../images/planner/highlights/swimming.png";
import townIcon from "../../../images/planner/highlights/town.png";
import transportStationIcon from "../../../images/planner/highlights/transport_station.png";
import viewpointIcon from "../../../images/planner/highlights/viewpoint.png";
import warningIcon from "../../../images/planner/highlights/warning.png";
import waterIcon from "../../../images/planner/highlights/water.png";
import waterfallIcon from "../../../images/planner/highlights/waterfall.png";
import wifiIcon from "../../../images/planner/highlights/wifi.png";
import wildlifeIcon from "../../../images/planner/highlights/wildlife.png";

/**
 * The map's own highlight markers (its highlight_icon_* sprite images, saved
 * as small PNGs), for lists that should show what the map shows. Keyed by
 * sprite name without the "highlight_icon_" prefix.
 */
const ICONS: { [name: string]: string } = {
  bnb: bnbIcon,
  bus_stop: busStopIcon,
  campground: campgroundIcon,
  cave: caveIcon,
  coffee: coffeeIcon,
  ev_charging: evChargingIcon,
  fastfood: fastfoodIcon,
  gate: gateIcon,
  healthcare: healthcareIcon,
  history: historyIcon,
  hostel: hostelIcon,
  hotel: hotelIcon,
  information: informationIcon,
  junction: junctionIcon,
  motel: motelIcon,
  parking: parkingIcon,
  peak: peakIcon,
  pharmacy: pharmacyIcon,
  picnic: picnicIcon,
  playground: playgroundIcon,
  post_office: postOfficeIcon,
  pub: pubIcon,
  restaurant: restaurantIcon,
  restroom: restroomIcon,
  shelter: shelterIcon,
  shop: shopIcon,
  storage: storageIcon,
  swimming: swimmingIcon,
  town: townIcon,
  transport_station: transportStationIcon,
  viewpoint: viewpointIcon,
  warning: warningIcon,
  water: waterIcon,
  waterfall: waterfallIcon,
  wifi: wifiIcon,
  wildlife: wildlifeIcon,
};

/** The names of the markers there are pictures of. */
export const HIGHLIGHT_ICON_NAMES = Object.keys(ICONS);

/** The map's marker for a general ("other") highlight. */
const GENERAL = 'information';

/**
 * Which of the map's highlight markers a highlight or POI type has (its
 * sprite name without the prefix) — the general one for a type the map has
 * no marker of its own for.
 */
export function highlightIconName(type: string | null | undefined): string {
  try {
    const sprite = String(POIUtility.fromString(type || 'other').hikeHighlightIcon() ?? '');
    const name = sprite.replace(/^highlight_icon_/, '');
    return name in ICONS ? name : GENERAL;
  } catch {
    return GENERAL;
  }
}

/** The picture of the map's highlight marker for a highlight or POI type. */
export function highlightIconUrl(type: string | null | undefined): string {
  return ICONS[highlightIconName(type)];
}
